import LoopIcon from "@mui/icons-material/Loop";
import {
  Box,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import AK from "../../../../assets/icons/AK.svg";
import AmK from "../../../../assets/icons/AmK.svg";
import ascendantIcon from "../../../../assets/icons/ascendantIcon.svg";
import atmakarakaIcon from "../../../../assets/icons/atmakarakaIcon.svg";
import BK from "../../../../assets/icons/BK.svg";
import DK from "../../../../assets/icons/DK.svg";
import GK from "../../../../assets/icons/GK.svg";
import ketuIcon from "../../../../assets/icons/ketuIcon.svg";
import MK from "../../../../assets/icons/MK.svg";
import moonIcon from "../../../../assets/icons/moonIcon.svg";
import PiK from "../../../../assets/icons/PiK.svg";
import PuK from "../../../../assets/icons/PuK.svg";
import rahuIcon from "../../../../assets/icons/rahuIcon.svg";
import rahuKetuIcon from "../../../../assets/icons/rahuKetuIcon.svg";
import rayIcon from "../../../../assets/icons/rayIcon.svg";
import sunIcon from "../../../../assets/icons/sunIcon.svg";
import { CustomIcon } from "../../../../global/components";
import { theme } from "../../../../utils/styles";
import analysisStyles from "../../Analysis.styles";

interface Symbols {
  [key: string]: string;
}

interface CustomProps {
  flipCardData: any;
}

const AnalysisFlipCards = (props: CustomProps) => {
  const classes = analysisStyles;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isFlipped, setIsFlipped] = useState(false);

  const symbols: Symbols = {
    moon: moonIcon,
    sun: sunIcon,
    ascendant: ascendantIcon,
    rahu: rahuIcon,
    ketu: ketuIcon,
    d1Ascendant: ascendantIcon,
    d1Rahu: rahuKetuIcon,
    d10Rahu: rahuKetuIcon,
    ray: rayIcon,
    d1RahuBhava: rahuKetuIcon,
    daraKaraka: DK,
    atmaKaraka: AK,
    gyatiKaraka: GK,
    putraKaraka: PuK,
    pitraKaraka: PiK,
    matraKaraka: MK,
    bhatraKaraka: BK,
    amatyaKaraka: AmK,
    karakamsa: atmakarakaIcon,
  };

  const handleCardClick = () => {
    setIsFlipped(!isFlipped);
  };
  return (
    <Grid item xl={6} lg={6} md={12} sm={12} xs={12} height={"100%"} p={1}>
      <Stack
        direction={"row"}
        className={isFlipped ? "is-flipped" : ""}
        sx={{ ...classes.cardStyle, position: "relative" }} // 👈 Add position relative here
        spacing={{ xl: 3, lg: 3, md: 2, sm: 2, xs: 1 }}
        onClick={handleCardClick}
      >
        {!isFlipped ? (
          <>
            {isMobile ? (
              <img
                src={symbols[props.flipCardData.symbol]}
                alt="Module not found..."
                style={{ width: "40px" }}
              />
            ) : (
              <img
                src={symbols[props.flipCardData.symbol]}
                alt="Module not found..."
                style={{ width: "80px" }}
              />
            )}

            <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
              <Typography sx={classes.labelTypo}>
                {props.flipCardData.name}
              </Typography>
              <Divider sx={{ border: "1px solid #FFFFFF", width: "30%" }} />
              <Box>
                {props.flipCardData.value.map((val: string, index: number) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 0.5,
                    }}
                  >
                    <Typography sx={classes.valueTypo}>{val}</Typography>
                  </Box>
                ))}
              </Box>
            </Stack>
            <Box
              sx={{
                position: "absolute",
                bottom: 8,
                right: 8,
              }}
            >
              <CustomIcon
                icon={
                  <LoopIcon sx={{ fontSize: "25px" }} htmlColor="#FFFFFF" />
                }
              />
            </Box>
          </>
        ) : (
          <>
            <Stack direction="column" spacing={1} sx={classes.flipCardContent}>
              <Typography sx={classes.flipLabelType}>
                {props.flipCardData.description}
              </Typography>
            </Stack>
            <Box
              sx={{
                position: "absolute",
                bottom: 8,
                left: -16,
              }}
            >
              <CustomIcon
                icon={
                  <LoopIcon sx={{ fontSize: "25px" }} htmlColor="#FFFFFF" />
                }
              />
            </Box>
          </>
        )}
      </Stack>
    </Grid>
  );
};

export default AnalysisFlipCards;
